module.exports = __webpack_public_path__ + "img/solution_subsystem_02@2x.8ab0ba16.png";